var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12Kougyou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#962F32;}\n\t.st1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.7,5.8c-0.6-2.2-4.7-4.2-9.2-3.7c-0.7,0.1-1.3,0.2-1.9,0.3L15.9,0L12,1l0.7,2.4C4.8,6.1,0.1,11.4,0.6,13 c4-2.7,8.5-4.7,13.1-5.9L19.3,28l3.9-1L17.6,6.3c0.6-0.1,1.3-0.2,1.9-0.3C22.2,5.7,24.9,5.6,27.7,5.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12,18 10,18 10,16 4,16 4,18 4,20 2,20 2,24 4,24 4,26 8,26 12,26 12,24 14,24 14,20 12,20  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12Kougyou);
export default __webpack_public_path__ + "static/media/12_kougyou.184ccdfac8c956cbf0e38fe9eb34f204.svg";
export { ForwardRef as ReactComponent };